import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bdbb301"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reserved-order-search-page" }
const _hoisted_2 = { class: "search-row" }
const _hoisted_3 = { class: "search-row-title single-ellipsis" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-input-icon-left search-order-input p-relative" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search pi-search-position" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "result-orders-block2"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "fast-search-row" }
const _hoisted_10 = { class: "radio-buttons" }
const _hoisted_11 = { class: "fast-search-btn" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "advanced-search-label" }
const _hoisted_16 = { class: "rows-data" }
const _hoisted_17 = { class: "row-data" }
const _hoisted_18 = { class: "row-data-label" }
const _hoisted_19 = { class: "row-data" }
const _hoisted_20 = { class: "row-data-label" }
const _hoisted_21 = { class: "row-data" }
const _hoisted_22 = { class: "row-data-label" }
const _hoisted_23 = { class: "row-data" }
const _hoisted_24 = { class: "row-data-label" }
const _hoisted_25 = { class: "row-data" }
const _hoisted_26 = { class: "row-data-label" }
const _hoisted_27 = { class: "row-data" }
const _hoisted_28 = { class: "row-data-label" }
const _hoisted_29 = { class: "row-data" }
const _hoisted_30 = { class: "row-data-label" }
const _hoisted_31 = { class: "row-data" }
const _hoisted_32 = { class: "row-data-label" }
const _hoisted_33 = { class: "row-data" }
const _hoisted_34 = { class: "row-data-label" }
const _hoisted_35 = { class: "row-data" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_38 = {
  key: 2,
  style: {"text-align":"center","padding-top":"15px","font-size":"20px","height":"100%"}
}
const _hoisted_39 = { class: "result-orders-block" }
const _hoisted_40 = { class: "page-header" }
const _hoisted_41 = { class: "page-header-title" }
const _hoisted_42 = { class: "filter-tag-items" }
const _hoisted_43 = {
  key: 0,
  class: "filter-tag-item"
}
const _hoisted_44 = {
  key: 1,
  class: "filter-tag-item"
}
const _hoisted_45 = {
  key: 2,
  class: "filter-tag-item"
}
const _hoisted_46 = {
  key: 3,
  class: "filter-tag-item"
}
const _hoisted_47 = {
  key: 4,
  class: "filter-tag-item"
}
const _hoisted_48 = {
  key: 5,
  class: "filter-tag-item"
}
const _hoisted_49 = { class: "advancedSearch-div" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_51 = { class: "default-grid-columns-template" }
const _hoisted_52 = { class: "column-title" }
const _hoisted_53 = { class: "column-title" }
const _hoisted_54 = { class: "column-title" }
const _hoisted_55 = { class: "column-title" }
const _hoisted_56 = { class: "column-title" }
const _hoisted_57 = { class: "column-title" }
const _hoisted_58 = { class: "column-title text-ellipsis" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_60 = {
  class: "list-orders",
  id: "list-orders"
}
const _hoisted_61 = { class: "default-grid-columns-template order-item-data row-with-border h27" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { class: "text-ellipsis" }
const _hoisted_64 = { class: "text-ellipsis" }
const _hoisted_65 = { class: "text-ellipsis" }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { class: "footer-action" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-f icon-back fs-10" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_RadioInput = _resolveComponent("RadioInput")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _directive_ripple = _resolveDirective("ripple")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("cashier.header.find-reserved-order")), 1),
      (_ctx.searchWas)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _ctx.orderFilter.keywords,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderFilter.keywords) = $event)),
                placeholder: _ctx.$t('cashier.label.search'),
                onInput: _cache[1] || (_cache[1] = ($event: any) => {
            _ctx.debounce(() => {
              _ctx.onChangeKeyword();
            })
            })
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.searchWas)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (!_ctx.orderFilter.advancedSearch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.type-number")), 1),
                  _createVNode(_component_TextInput, {
                    clearable: true,
                    modelValue: _ctx.orderFilter.searchValue,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.orderFilter.searchValue) = $event)),
                    ref: "searchInput"
                  }, null, 8, ["modelValue"]),
                  _withDirectives((_openBlock(), _createElementBlock("button", {
                    class: "p-ripple",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickSearchBy && _ctx.onClickSearchBy(...args)))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.search")), 1)
                  ])), [
                    [_directive_ripple]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_RadioInput, {
                    value: 1,
                    modelValue: _ctx.orderFilter.searchType,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.orderFilter.searchType) = $event)),
                    label: _ctx.$t('cashier.label.order-number'),
                    name: "searchBy"
                  }, null, 8, ["modelValue", "label"]),
                  _createVNode(_component_RadioInput, {
                    value: 2,
                    modelValue: _ctx.orderFilter.searchType,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.orderFilter.searchType) = $event)),
                    label: _ctx.$t('cashier.label.ticket-number'),
                    name: "searchBy"
                  }, null, 8, ["modelValue", "label"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.orderFilter.advancedSearch = true))
                  }, _toDisplayString(_ctx.$t("cashier.label.advanced-search")), 1),
                  _hoisted_13
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("cashier.label.advanced-search")), 1),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("cashier.label.order-number")), 1),
                    _createVNode(_component_TextInput, {
                      clearable: true,
                      modelValue: _ctx.orderFilter.orderNumber,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.orderFilter.orderNumber) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("cashier.label.customer-name")), 1),
                    _createVNode(_component_TextInput, {
                      clearable: true,
                      modelValue: _ctx.orderFilter.customerName,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.orderFilter.customerName) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("cashier.label.mobile")), 1),
                    _createVNode(_component_TextInput, {
                      clearable: true,
                      modelValue: _ctx.orderFilter.mobile,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.orderFilter.mobile) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("cashier.label.ext-sys-number")), 1),
                    _createVNode(_component_TextInput, {
                      clearable: true,
                      modelValue: _ctx.orderFilter.pnr,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.orderFilter.pnr) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("cashier.label.businessClints")), 1),
                    _createVNode(_component_Dropdown, {
                      modelValue: _ctx.orderFilter.businessClientId,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.orderFilter.businessClientId) = $event)),
                      options: _ctx.clients,
                      optionLabel: "name",
                      optionValue: "id",
                      filter: "",
                      filterBy: "name",
                      class: "custom-drop-down",
                      showClear: true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("cashier.label.group-name")), 1),
                    _createVNode(_component_TextInput, {
                      clearable: true,
                      modelValue: _ctx.orderFilter.groupName,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.orderFilter.groupName) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('cashier.filters.arrival-date-from')), 1),
                    _createVNode(_component_DateInput, {
                      clearable: true,
                      modelValue: _ctx.orderFilter.arrivalDateFrom,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.orderFilter.arrivalDateFrom) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('cashier.filters.arrival-date-to')), 1),
                    _createVNode(_component_DateInput, {
                      clearable: true,
                      modelValue: _ctx.orderFilter.arrivalDateTo,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.orderFilter.arrivalDateTo) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('cashier.filters.products')), 1),
                    _createVNode(_component_Dropdown, {
                      modelValue: _ctx.orderFilter.productId,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.orderFilter.productId) = $event)),
                      options: _ctx.products,
                      optionLabel: "name",
                      optionValue: "id",
                      class: "custom-drop-down",
                      showClear: true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("button", {
                      class: "advanced-search-btn",
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onClickSearch && _ctx.onClickSearch(...args)))
                    }, [
                      _hoisted_37,
                      _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.search")), 1)
                    ])
                  ])
                ])
              ])),
          (_ctx.showNoResult)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.$t("cashier.label.no-result")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("cashier.header.search-results")), 1),
        _createElementVNode("div", _hoisted_42, [
          (_ctx.orderFilter.keywords)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.quick-search")) + ": " + _toDisplayString(_ctx.orderFilter.keywords) + " ", 1),
                _createElementVNode("span", {
                  onClick: _cache[17] || (_cache[17] = ($event: any) => ((_ctx.orderFilter.keywords = ''), _ctx.onClickSearch())),
                  class: "icon-f icon-delete-cross fs-10"
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderFilter.orderNumber)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.order-number")) + ": " + _toDisplayString(_ctx.orderFilter.orderNumber) + " ", 1),
                _createElementVNode("span", {
                  onClick: _cache[18] || (_cache[18] = ($event: any) => ((_ctx.orderFilter.orderNumber = ''), _ctx.onClickSearch())),
                  class: "icon-f icon-delete-cross fs-10"
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderFilter.customerName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.customer-name")) + ": " + _toDisplayString(_ctx.orderFilter.customerName) + " ", 1),
                _createElementVNode("span", {
                  onClick: _cache[19] || (_cache[19] = ($event: any) => ((_ctx.orderFilter.customerName = ''), _ctx.onClickSearch())),
                  class: "icon-f icon-delete-cross fs-10"
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderFilter.mobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.mobile")) + ": " + _toDisplayString(_ctx.orderFilter.mobile) + " ", 1),
                _createElementVNode("span", {
                  onClick: _cache[20] || (_cache[20] = ($event: any) => ((_ctx.orderFilter.mobile = ''), _ctx.onClickSearch())),
                  class: "icon-f icon-delete-cross fs-10"
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderFilter.pnr)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.ext-sys-number")) + ": " + _toDisplayString(_ctx.orderFilter.pnr) + " ", 1),
                _createElementVNode("span", {
                  onClick: _cache[21] || (_cache[21] = ($event: any) => ((_ctx.orderFilter.pnr = ''), _ctx.onClickSearch())),
                  class: "icon-f icon-delete-cross fs-10"
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.orderFilter.businessClientId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.businessClints")) + ": " + _toDisplayString(_ctx.getClientName(_ctx.orderFilter.businessClientId)) + " ", 1),
                _createElementVNode("span", {
                  onClick: _cache[22] || (_cache[22] = ($event: any) => ((_ctx.orderFilter.businessClientId = null), _ctx.onClickSearch())),
                  class: "icon-f icon-delete-cross fs-10"
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.filterExist)
            ? (_openBlock(), _createElementBlock("div", {
                key: 6,
                class: "showAll",
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
              }, _toDisplayString(_ctx.$t("button.showAll")), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("button", {
            onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.advancedSearch && _ctx.advancedSearch(...args)))
          }, [
            _hoisted_50,
            _createTextVNode(_toDisplayString(_ctx.$t("cashier.label.advanced-search")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("cashier.label.order-number")), 1),
        _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t("product.productName")), 1),
        _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t("start-date.label")), 1),
        _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t("cashier.label.customer-name")), 1),
        _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t("cashier.label.mobile")), 1),
        _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$t("label.channel")), 1),
        _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$t("cashier.label.order-client-type")), 1),
        _hoisted_59
      ]),
      _createElementVNode("div", _hoisted_60, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
          return (_openBlock(), _createElementBlock("div", {
            key: order.id,
            class: "order-item"
          }, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", {
                class: "order-number",
                onClick: ($event: any) => (_ctx.showOrderDetails(order.id))
              }, _toDisplayString(order.orderNumber), 9, _hoisted_62),
              _createElementVNode("div", _hoisted_63, _toDisplayString(order.productName), 1),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", null, _toDisplayString(order.startDate), 1)
              ]),
              _createElementVNode("div", _hoisted_65, _toDisplayString(order.leadCustomerFullName), 1),
              _createElementVNode("div", null, _toDisplayString(order.leadCustomerMobile == "0" ? "" : order.leadCustomerMobile), 1),
              _createElementVNode("div", null, _toDisplayString(order.channelName), 1),
              _createElementVNode("div", null, _toDisplayString(order.businessOrder
                ? _ctx.$t("cashier.label.business")
                : _ctx.$t("cashier.label.private")), 1),
              _createElementVNode("div", {
                class: "show-details-action",
                onClick: ($event: any) => (_ctx.showOrderDetails(order.id))
              }, _toDisplayString(_ctx.$t("orders.orderDetails")), 9, _hoisted_66)
            ])
          ]))
        }), 128))
      ])
    ], 512), [
      [_vShow, _ctx.searchWas]
    ]),
    _createElementVNode("div", _hoisted_67, [
      _createElementVNode("button", {
        onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
        type: "button"
      }, [
        _hoisted_68,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.back")), 1)
      ])
    ])
  ], 512)), [
    [_vShow, _ctx.loaded]
  ])
}